import PropTypes from "prop-types";
import React from "react";
import { first, isArray } from "lodash";
import TextField from "@mui/material/TextField";

const InputField = ({
  input,
  type,
  meta,
  hintText,
  id,
  rows,
  disabled,
  dataTest,
  containerClassName,
  errorText,
  checkError,
  isError,
  tabIndex
}) => {
  // we will display the error message, only if
  // the field has been edited to a new value
  const isInvalidate = meta.touched && meta.error && !!meta.error.length;
  const errorMessage = isInvalidate
    ? (isArray(meta.error) ? first(meta.error) : meta.error)
    : "";
  return (
    <div className={`input-field-wrapper ${containerClassName}`}>
      {!checkError ? <TextField
        {...input}
        variant="standard"
        value={input.value}
        multiline={rows > 1}
        rows={rows}
        type={type}
        label={hintText}
        id={id}
        disabled={disabled}
        data-test={dataTest}
        tabIndex={tabIndex}
        fullWidth
        onChange={(e) => input.onChange(e.target.value)}
      /> : <TextField
          {...input}
          variant="standard"
          value={input.value}
          multiline={rows > 1}
          rows={rows}
          type={type}
          label={hintText}
          id={id}
          disabled={disabled}
          data-test={dataTest}
          helperText={isError ? errorText : undefined}
          onChange={(e) => checkError(e.target.value)}
          error={isError}
          tabIndex={tabIndex}
          fullWidth
        />}
      <div className="validation-error"
        data-test={`${dataTest}-error`}>
        {errorMessage}
      </div>
    </div>
  );
};

InputField.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  hintText: PropTypes.string,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  dataTest: PropTypes.string,
  rows: PropTypes.number,
  containerClassName: PropTypes.string,
  errorText: PropTypes.string,
  checkError: PropTypes.func,
  isError: PropTypes.bool,
  tabIndex: PropTypes.number
};

export default InputField;

